<template>
  <div class="filtrate-main">
    <div class="filtrate-list" v-if="showIntention">
      <div class="filtrate-item filtrate-name">求职意向：</div>
      <div class="filtrate-item-content">
        <template v-if="JSON.stringify(userIntentions) != '{}' && userIntentions.profession_ids.length > 0">
          <div class="filtrate-item" :class="[ queryData.profession_ids && queryData.profession_ids == userIntentions.profession_ids[index] ? 'active' : '' ]" v-for="(item, index) in userIntentions.professions" :key="index + 'industries'" @click="select($event, 'profession_ids', {name: userIntentions.profession_ids[index]})">
            {{item}}
          </div>
          <div class="filtrate-item update-text" @click.stop="intentionShow = true">更新求职意向<i class="iconchevron-right iconfont"></i></div>
        </template>
        <template v-else>
          <div class="filtrate-item not-text">
            <span>暂未设置求职意向</span><span class="setting-text" @click.stop="intentionShow = true">立即设置<i class="iconchevron-right iconfont"></i></span>
          </div>
        </template>
      </div>
    </div>
    <div class="filtrate-list" style="flex: 1" :class="[isMore ? 'more' : '']" v-if="isCompanySearch">
      <div class="filtrate-item filtrate-name">职位地点：</div>
      <div class="filter-first">
        <div class="filtrate-item-content">
          <div
            class="filtrate-item"
            v-for="(item, index) in conditions.citys"
            :key="index"
            :class="[
              (
                (!queryData.city_names && item === '全国')
                || queryData.city_names === item
              )
              ? 'active' : ''
            ]"
            @click="select($event, 'city_names', {name: item})">
            {{item}}
          </div>
        </div>
        <div class="filtrate-list-more" :class="[isMore ? 'active' : '']" @click="clickMoreCity">
          {{!isMore ? '更多' : '收起'}}<i class="iconfont iconchevron-down"></i>
        </div>
      </div>
    </div>
    <div class="filtrate-list" :class="[isMore ? 'more' : '']" v-if="isCompanySearch">
      <div class="filtrate-item filtrate-name">求职意向：</div>
      <div class="filtrate-item-content">
        <div
          class="filtrate-item"
          v-for="(item, index) in conditions.profession_level"
          :key="index"
          :class="[
            (
              (queryData.profession_level1.length == 0 && item === '不限')
              || queryData.profession_level1.indexOf(item) > -1
            )
            ? 'active' : ''
          ]"
          @click="select($event, 'profession_level1', {name: item})">
          {{item}}
        </div>
      </div>
      <div class="filtrate-list-more" :class="[isMore ? 'active' : '']" @click="isMore = !isMore">
        {{!isMore ? '更多' : '收起'}}<i class="iconfont iconchevron-down"></i>
      </div>
    </div>
    <div class="filtrate-list" :class="[isMore ? 'more' : '']">
      <div class="filtrate-item filtrate-name">行业领域：</div>
      <div class="filtrate-item-content">
        <div
          class="filtrate-item"
          v-for="(item, index) in conditions.industries"
          :key="index"
          :class="[
            (
              (!queryData.company_industry && item.name === '不限')
              || queryData.company_industry === item.name
            )
            ? 'active' : ''
          ]"
          @click="select($event, 'company_industry', item)">
          {{item.name}}
        </div>
      </div>
      <div class="filtrate-list-more" :class="[isMore ? 'active' : '']" @click="isMore = !isMore">
        {{!isMore ? '更多' : '收起'}}<i class="iconfont iconchevron-down"></i>
      </div>
    </div>
    <div class="filtrate-list" :class="[isMore ? 'more' : '']">
      <div class="filtrate-item filtrate-name">职位类型：</div>
      <div class="filtrate-item-content">
        <div
          class="filtrate-item"
          v-for="(item, index) in conditions.job_nature"
          :key="index"
          :class="[
            (
              (!queryData.job_nature || queryData.job_nature === '不限')
              && item.name === '不限'
            )
            || (queryData.job_nature === item.name)
            ? 'active' : ''
          ]"
          @click="select($event, 'job_nature', item)">
          {{item.name}}
        </div>
      </div>
    </div>
    <intention :show="intentionShow" @clone="intentionShow = false;" @update="getIntention"/>
    <div class="filtrate-select">
      <div class="filtrate-select-menu">
        <span>学历要求：</span>
        <div class="filtrate-select-menu-select">
          <el-dropdown trigger="click" @command="(data, $event) => select($event, 'degree_name', data)">
            <span class="el-dropdown-link" :class="[queryData.degree_name && queryData.degree_name !== '不限' ? 'active' : '']">
              {{queryData.degree_name || '不限'}}<i class="iconfont iconxiala"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in conditions.degrees"
                :key="index"
                :command="item"
                :class="
                  [
                    ((!queryData.degree_name || queryData.degree_name === '不限') && item.name === '不限') || queryData.degree_name === item.name ? 'active' : ''
                  ]
                ">
                {{item.name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filtrate-select-menu">
        <span>经验要求：</span>
        <div class="filtrate-select-menu-select">
          <el-dropdown trigger="click" @command="(data, $event) => select($event, 'experience', data)">
            <span class="el-dropdown-link" :class="[queryData.experience && queryData.experience !== '不限' ? 'active' : '']">
              {{queryData.experience || '不限'}}<i class="iconfont iconxiala"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in conditions.experiences"
                :key="index"
                :command="item"
                :class="
                  [
                    ((!queryData.experience || queryData.experience === '不限') && item.name === '不限')
                    || queryData.experience === item.name
                    ? 'active' : ''
                  ]
                ">
                {{item.name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filtrate-select-menu">
        <span>公司规模：</span>
        <div class="filtrate-select-menu-select">
          <el-dropdown trigger="click" @command="(data, $event) => select($event, 'company_scale', data)">
            <span class="el-dropdown-link" :class="[queryData.company_scale && queryData.company_scale !== '不限' ? 'active' : '']">
              {{queryData.company_scale || '不限'}}<i class="iconfont iconxiala"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in conditions.scales"
                :key="index"
                :command="item"
                :class="
                  [
                    ((!queryData.company_scale || queryData.company_scale === '不限') && item.name === '不限')
                    || queryData.company_scale === item.name
                    ? 'active' : ''
                  ]
                ">
                {{item.name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filtrate-select-menu">
        <span>公司类型：</span>
        <div class="filtrate-select-menu-select">
          <el-dropdown trigger="click" @command="(data, $event) => select($event, 'company_nature', data)">
            <span class="el-dropdown-link" :class="[queryData.company_nature && queryData.company_nature !== '不限' ? 'active' : '']">
              {{queryData.company_nature || '不限'}}<i class="iconfont iconxiala"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in conditions.nature"
                :key="index"
                :command="item"
                :class="
                  [
                    ((!queryData.company_nature || queryData.company_nature === '不限') && item.name === '不限')
                    || queryData.company_nature === item.name
                    ? 'active' : ''
                  ]
                ">
                {{item.name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filtrate-select-menu">
        <span>薪资要求：</span>
        <div class="filtrate-select-menu-select">
          <el-dropdown trigger="click" @command="(data, $event) => select($event, 'salary', data)">
            <span class="el-dropdown-link" :class="[queryData.salary && queryData.salary !== '不限' ? 'active' : '']">
              {{text || '不限'}}<i class="iconfont iconxiala"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in conditions.salaries"
                :key="index"
                :command="item"
                :class="
                  [
                    ((!queryData.salary || queryData.salary === '不限') && item.code === '不限')
                    || queryData.salary === item.code
                    ? 'active' : ''
                  ]
                ">
                {{item.name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filtrate-reset" @click="$emit('reset');">清空筛选</div>
    </div>
  </div>
</template>
<script>
import conditions from '@/assets/json/conditions'
import {mapState} from "vuex";
import intention from '@/components/jobs/intention';
import api from "../../../api";
export default {
  name: 'fitrate',
  props: {
    ssr: {
      type: Boolean,
      default: false
    },
    queryData: {
      type: Object
    },
    isCompanySearch: {
      type: Boolean,
      default: false
    },
    showIntention: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      conditions,
      isMore: false,
      intentionShow: false
    };
  },
  computed: {
    text() {
      let text = '';
      for (let i = 0; i < this.conditions.salaries.length; i++) {
        if (this.conditions.salaries[i].code === this.queryData.salary) {
          text = this.conditions.salaries[i].name;
          break;
        }
      }
      return text;
    },
    ...mapState('jobs', ['userIntentions'])
  },
  watch: {
    queryData: {
      deep: true,
      immediate: true,
      handler() {
      }
    }
  },
  created() {
    this.getIntention()
  },
  methods: {
    a (data) {
      console.log(data);
    },
    select($event, key, data) {
      if (this.ssr) {
        $event.preventDefault();
        return false;
      }
      this.$emit('select', { $event, key, data });
    },
    clickMoreCity(){
      this.$emit('showMoreCity')
    },
    getClassAction(key, data) {
      let queryData = this.queryData || {};
      let isActive = (queryData[key] === data.name || (queryData[key] == data.code && data.code) || (!queryData[key] && data.name == '不限'));

      return isActive ? 'active' : '';
    },
    // 获取求职意向
    async getIntention(options) {
      let userIntentions = await api.recruit.jobIntention({"platform": 'pc'});
      if (userIntentions.code && userIntentions.code === 1000) {
        if(userIntentions.data.profession_ids.length > 0){
          this.select(null,'profession_ids', {name: userIntentions.data.profession_ids[0]})
        }
        await this.$store.dispatch('jobs/getIntention', userIntentions.data);
      }
    },
  },
  components: {
    intention
  }
}
</script>
<style lang="scss" scoped>
.filtrate-main {
  width: 100%;
  padding: 32px 26px 0;
  box-sizing: border-box;
  background: #fff;
  position: relative;
  * {
    box-sizing: border-box;
  }
  .filtrate-reset {
    position: absolute;
    font-size: 14px;
    color: #9C9C9C;
    top: 26px;
    right: 0px;
    cursor: pointer;
    &:hover {
      color: #FF6644;
    }
  }
  .filtrate-list {
    width: 100%;
    height: 24px;
    display: flex;
    margin-bottom: 12px;
    overflow: hidden;
    &:last-child {
      margin-bottom: 0;
    }
    &.more {
      height: auto;
      overflow: auto;
    }
    .filtrate-item-content {
      display: flex;
      flex-wrap: wrap;
    }
    .filtrate-list-more {
      flex: none;
      cursor: pointer;
      color: #9C9C9C;
      font-size: 14px;
      display: flex;
      align-items: center;
      align-self: flex-start;
      margin-top: 4px;
      .iconfont {
        transform-origin: 50% 50%;
        display: block;
        margin-left: 4px;
        // transition: all .3s ease;
      }
      &:hover {
        color: #FF6644;
      }
      &.active {
        .iconfont {
          transform: rotate(180deg);
        }
      }
    }
    .filtrate-item {
      margin-bottom: 10px;
      flex: none;
      display: block;
      height: 24px;
      margin-right: 8px;
      padding: 0 10px;
      line-height: 24px;
      font-size: 14px;
      color: #606060;
      cursor: pointer;
      border-radius: 2px;
      &:hover {
        color: #FF6644;
      }
      &:last-child {
        margin-right: 0;
      }
      &.filtrate-name {
        cursor: auto;
        color: #404040;
      }
      &.active {
        color: #fff;
        background: #FF6644;
      }
      &.update-text{
        color: #FF6644;
      }
      &.not-text{
        padding-left: 0;
        &:hover{
          color: #606060;
          cursor: auto;
        }
        .setting-text{
          color: #ff6644;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
    .filter-first{
      display: flex;
      flex: 1;
      justify-content: space-between;
    }
  }
  .filtrate-select {
    border-top: 1px solid #F9F9F9;
    height: 60px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #404040;
    position: relative;
    padding: 0 11px;
    .filtrate-select-menu {
      display: flex;
      align-items: center;
    }
    .filtrate-select-menu-select {
      min-width: 134px;
    }
  }
}
</style>
<style lang="scss">
// .filtrate-main {

  .el-dropdown {
    cursor: pointer;
  }
  .el-dropdown-link {
    display: inline-block;
    height: 28px;
    line-height: 26px;
    padding: 0 18px;
    outline: none;
    color: #606060;
    border: 1px solid #F9F9F9;
    margin-right: 16px;
    border-radius: 2px;
    .iconfont {
      display: inline-block;
      font-size: 12px;
      margin-left: 6px;
      transform: scale(.8);
      color: #bcbcbc;
    }
    &:hover,
    &.active {
      color: #FF6644;
      .iconfont {
        color: #FF6644;
      }
    }
  }
  .el-dropdown-menu__item.active {
    color: #FF6644!important;
  }
  .el-dropdown-menu__item:hover {
    background: rgba(255, 102, 68, .04)!important;
    color: #FF6644!important;
  }
// }
</style>
